import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PolicyDetailsComponent } from './policy-details.component';

const MODULES = [
  CommonModule,
  TranslateModule
];

const COMPONENTS = [
  PolicyDetailsComponent
];

@NgModule({
  imports: [
    MODULES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    PolicyDetailsComponent
  ]
})
export class PolicyDetailsModule { }
